<template>
  <v-icon v-if="isVip" color="#FFC800" :size="size"> mdi-crown </v-icon>
</template>

<script>
import { clinicMembership } from '@/data/constants';

export default {
  name: 'VipIcon',
  props: {
    membership: {
      type: String,
      default: null,
    },
    size: {
      type: [String, Number],
      default: 16,
    },
  },
  computed: {
    isVip() {
      return this.membership === clinicMembership.vip;
    },
  },
};
</script>
